import React, { Component } from 'react';
import { Card, CardText, CardBody, Button, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import { SelectInput, TextInput, SlYesNo, SlButton, SlPageTitle, SlSectionTitle, SlFormEntryRow } from '../editors'
import { metadataService, userService } from '../../_services'
import { connect } from "react-redux";
import { Alert } from 'reactstrap';
import validator from 'validator';
import { history } from "../../_helpers";
import { registrationActions } from "../../_actions";
import { registrationConstants } from '../../_constants';

class ProfileInfo extends Component {
    static displayName = ProfileInfo.name;

    constructor(props) {
        super(props);
        this.state = {

            formValue: {
                firstName: this.props.firstName,
                lastName: this.props.lastName,
                email: this.props.email,
                confirmEmail: this.props.confirmEmail,
                mobilePhone: this.props.mobileNumber,
                address1: this.props.address,
                address2: this.props.address2,
                city: this.props.city,
                state: this.props.state,
                postalCode: this.props.postalCode,
                selectedLanguage: userService.getUserLanguage(),
            },
            firstNameError: false,
            lastNameError: false,
            emailError: false,
            emailConfirmError: false,
            mobilePhoneError: false,
            addressError: false,
            cityError: false,
            stateError: false,
            zipCodeError: false,
            fromProfileInfo: true,
            fieldErrors: [],
            formError: true,
        };
        this.state.formError = this.formHasError(this.state);
        this.handleInput = this.handleInput.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.formHasError = this.formHasError.bind(this);
        this.handleChangeState = this.handleChangeState.bind(this);
    }
    componentDidMount() {
        if (!this.props.completedSteps.find(t => t === registrationConstants.NEW_EXISTING_CUSTOMER_REQUEST || t === registrationConstants.NEW_CUSTOMER_REQUEST)) {
            history.push("/SignUpCustomerStatus")
        }
    }


    handleInput = ({ target: { name, value } }) => {

        const formValue = { ...this.state.formValue, [metadataService.jsonFieldName(name)]: value };
        if (name.toLowerCase() === "selectedlanguage") {
            userService.setUserLanguage(value)
        }
        this.handleChangeState({ formValue });
    };

    handleBlur = ({ target: { name, value } }) => {

    };
    handleChangeState(newState) {
        let nextState = { ...this.state, ...newState }
        nextState.formError = this.formHasError(nextState);

        this.setState(nextState)
    }

    handleSubmit = () => {
        const { dispatch } = this.props;

        let formError = this.handleValidation();

        if (!formError) {
            let personalInformation = {
                firstName: this.state.formValue.firstName,
                lastName: this.state.formValue.lastName,
                email: this.state.formValue.email,
                confirmEmail: this.state.formValue.confirmEmail,
                mobileNumber: this.state.formValue.mobilePhone,
                address: this.state.formValue.address1,
                address2: this.state.formValue.address2,
                city: this.state.formValue.city,
                state: this.state.formValue.state,
                postalCode: this.state.formValue.postalCode,
                language: this.state.formValue.selectedLanguage,
                confirmationSummaryScreen: this.props.confirmationSummaryScreen,
                fromProfileInfo: this.state.fromProfileInfo
            };

            dispatch(registrationActions.handlePersonalInformationRequest(personalInformation));
        }
    }

    handleValidation = () => {

        let formError = this.formHasError(this.state);
        this.setState((state, props) => {
            return {
                formError: formError
            };
        });

        return formError;

    };
    formHasError(checkState) {

        let firstNameError = false;
        let lastNameError = false;
        let emailError = false;
        let emailConfirmError = false;
        let mobilePhoneError = false;
        let addressError = false;
        let cityError = false;
        let stateError = false;
        let zipCodeError = false;
        let fieldErrors = [];

        //this.setState({ fieldErrors: fieldErrors })


        if (checkState.formValue.email) {
            if (checkState.formValue.email.length <= 5 || !metadataService.emailRegex(checkState.formValue.email) || !validator.isEmail(checkState.formValue.email)) {
                fieldErrors.push({ fieldName: "Email", messageName: "InvalidFormat" });
                emailError = true;
            } else if (!validator.equals(checkState.formValue.email, checkState.formValue.confirmEmail || '')) {
                fieldErrors.push({ fieldName: "ConfirmEmail", messageName: "ConfirmEmail" });
                emailConfirmError = true;
            }
        }

        if(checkState.formValue.mobilePhone){
            if( checkState.formValue.mobilePhone.length < 10
                || !validator.isMobilePhone(checkState.formValue.mobilePhone + '', 'en-US')
                || metadataService.MobileNumberBeginsWithOneOrZero(checkState.formValue.mobilePhone)){
                mobilePhoneError = true;
                fieldErrors.push({ fieldName: "MobilePhone", messageName: "MobilePhoneError" });
            }
        }       
        checkState.fieldErrors = fieldErrors;
        if (validator.isEmpty(checkState.formValue.firstName + '') ||
            validator.isEmpty(checkState.formValue.lastName + '') ||
            validator.isEmpty(checkState.formValue.email + '') ||
            validator.isEmpty(checkState.formValue.address1 + '') ||
            validator.isEmpty(checkState.formValue.city + '') ||
            validator.isEmpty(checkState.formValue.state + '') ||
            validator.isEmpty(checkState.formValue.postalCode + '')
        ) {
            return true;
        }
        firstNameError = validator.isEmpty(checkState.formValue.firstName);
        lastNameError = validator.isEmpty(checkState.formValue.lastName);
        emailError = (validator.isEmpty(checkState.formValue.email) || !validator.isEmail(checkState.formValue.email));
        emailConfirmError = (!validator.equals(checkState.formValue.email, checkState.formValue.confirmEmail));       
        addressError = (validator.isEmpty(checkState.formValue.address1));
        cityError = (validator.isEmpty(checkState.formValue.city));
        stateError = (validator.isEmpty(checkState.formValue.state));
        zipCodeError = (validator.isEmpty(checkState.formValue.postalCode));

        return ((firstNameError) || (lastNameError) || (emailError) || (emailConfirmError) || (mobilePhoneError) || (addressError) || (cityError) || (stateError) || (zipCodeError));
    }


    render() {
        const { loggedIn, error } = this.props;
        const { formError, firstNameError } = this.state;

        return (
            <div className="ProfileInfo">
                <SlPageTitle pageName="SignUpMain" />
                <SlSectionTitle sectionName='My_Info' />
                <div>
                    <Card>
                        <CardBody className="noPadBottom">

                            <SlFormEntryRow>
                                <TextInput name="FirstName" value={this.state.formValue.firstName} onChange={this.handleInput} maxLength='30' fieldErrors={this.state.fieldErrors} isRequired={true} />
                            </SlFormEntryRow>
                            <SlFormEntryRow>
                                <TextInput name="LastName" value={this.state.formValue.lastName} onChange={this.handleInput} maxLength='30' fieldErrors={this.state.fieldErrors} isRequired={true} />
                            </SlFormEntryRow>

                            <SlFormEntryRow>
                                <TextInput name="Email" value={this.state.formValue.email} onChange={this.handleInput} fieldErrors={this.state.fieldErrors} isRequired={true} type='email' maxLength={256} />
                            </SlFormEntryRow>

                            <SlFormEntryRow>
                                <TextInput name="ConfirmEmail" value={this.state.formValue.confirmEmail} onChange={this.handleInput} fieldErrors={this.state.fieldErrors} isRequired={true} type='email' maxLength={256} />
                            </SlFormEntryRow>

                            <SlFormEntryRow>

                                <TextInput name="MobilePhone" value={this.state.formValue.mobilePhone} onChange={this.handleInput} isRequired={true} fieldErrors={this.state.fieldErrors} type='number' maxLength='10' />
                            </SlFormEntryRow>

                            <SlFormEntryRow>
                                <TextInput name="Address1" label={metadataService.getFieldNameLabel("Address")} value={this.state.formValue.address1} onChange={this.handleInput} maxLength='60' isRequired={true} fieldErrors={this.state.fieldErrors} />
                            </SlFormEntryRow>
                            {/*<SlFormEntryRow>*/}
                            {/*    <TextInput name="Address2" value={this.state.formValue.address2} onChange={this.handleInput} isRequired={false} maxLength='60' />*/}
                            {/*</SlFormEntryRow>*/}
                            <SlFormEntryRow>
                                <TextInput name="City" value={this.state.formValue.city} onChange={this.handleInput} maxLength='60' isRequired={true} fieldErrors={this.state.fieldErrors} />
                            </SlFormEntryRow>
                            <SlFormEntryRow>
                                <Row>
                                    <Col><TextInput name="ZipCode" value={this.state.formValue.postalCode} onChange={this.handleInput} maxLength='5' isRequired={true} fieldErrors={this.state.fieldErrors} /></Col>
                                    <Col><SelectInput name="State" value={this.state.formValue.state} options={metadataService.getLookup("state")} onChange={this.handleInput} /></Col>
                                </Row>
                            </SlFormEntryRow>                       
                            <SlFormEntryRow>
                                <SelectInput name="SelectedLanguage" customLabel={"LanguagePrefrence"} value={this.state.formValue.selectedLanguage} options={metadataService.getLookup("language")} onChange={this.handleInput} />
                            </SlFormEntryRow>
                           

                        </CardBody>
                    </Card>
                </div>
                <SlFormEntryRow>
                    {/* <div className="text-center" hidden>
                        <Button outline color="secondary" size="md">Next</Button>
                    </div> */}
                    <div className="text-center">
                        <SlButton name="Next" onClick={this.handleSubmit} disabled={this.state.formError} />
                    </div>
                </SlFormEntryRow>
            </div>
        );
    }
}

function mapStateToProps(store) {
    const { loggedIn } = store.authentication;

    const { existingCustomer, confirmationSummaryScreen, error, firstName, lastName, email, confirmEmail, mobileNumber, address, address2, city, state, postalCode, language, completedSteps } = store.registration;

    return {
        loggedIn, confirmationSummaryScreen, existingCustomer, error, firstName, lastName, email, confirmEmail, mobileNumber, address, address2, city, state, postalCode, language, completedSteps
    };
}

const connectedProfileInfo = connect(mapStateToProps)(ProfileInfo);
export { connectedProfileInfo as ProfileInfo };